export default __webpack_public_path__ + "static/media/bg.a8a86b26.webp";